import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Card } from 'primereact/card';

import Header from '@components/Header';
import CardAnimation from '@components/CardAnimation';

import './style.scss'

class Reports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingBtn: false,
      typeProcess: null,
    };
  }

  render() {
    const { t, history } = this.props;

    return (
      <div className="p-grid reports">
        <div className="p-col-12">
          <Header title={t('Reportes')} />
          <p>{t('Selecciona el reporte deseado')}</p>
        </div>

        <div className="p-col-12 p-lg-4 p-md-6 p-d-flex p-jc-center ">
          <CardAnimation
            title={t('Usuarios internos')}
            description={t('Obtén el total de registros de usuarios internos por país, donde podrás descargar el reporte y/o también el detalle de usuarios.')}
            background="assets/img/employee.jpg"
            action={() => { history.push('/reports/user/internal') }}
          />
        </div>
        <div className="p-col-12 p-lg-4 p-md-6 p-d-flex p-jc-center">
          <CardAnimation
            title={t('Usuarios Proveedores')}
            description={t('Obtén el total de provedores por país, donde podrás descargar el reporte  y/o el detalle de provedores.')}
            background="assets/img/provedor.jpeg"
            action={() => { history.push('/reports/user/suppliers') }}
          />
        </div>
        <div className="p-col-12 p-lg-4 p-md-6 p-d-flex p-jc-center">
          <CardAnimation
            title={t('Procesos')}
            description={t('Obtén el detalle de folios por proceso seleccionado y podrás descargar los diferentes reportes que se tienen.')}
            background="assets/img/procesos.jpg"
            action={() => { history.push('/reports/process') }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {

};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Reports);
